import { Box } from "@mui/material";

const SHADOW_WIDTH = "50px";

/**
 * Class toggled (via ref, not React state) on the scroll container once it's scrolled
 * horizontally. Scoped this way so scrolling doesn't trigger a re-render of the table.
 */
export const HORIZONTALLY_SCROLLED_CLASS = "pinned-shadow-visible";

/**
 * Overlay marking the boundary of the last pinned column: sits just outside it, over the
 * scrollable columns, fading from a dark tint (at the pinned boundary) to transparent (further
 * into the scrollable area). Rendered as a child of the last pinned cell, which must be
 * `position: relative`/`sticky` and allow this overlay to overflow its own right edge.
 *
 * Hidden until the table is scrolled horizontally (see HORIZONTALLY_SCROLLED_CLASS).
 */
export const PinnedColumnShadow = () => (
  <Box
    aria-hidden
    sx={{
      position: "absolute",
      left: "100%",
      top: 0,
      bottom: 0,
      width: SHADOW_WIDTH,
      borderLeft: "1px solid #D1D7E0",
      background:
        "linear-gradient(270deg, rgba(52, 61, 80, 0) 0%, rgba(52, 61, 80, 0.15) 100%)",
      pointerEvents: "none",
      opacity: 0,
      transition: "opacity 0.2s ease",
      [`.${HORIZONTALLY_SCROLLED_CLASS} &`]: {
        opacity: 1,
      },
    }}
  />
);
